// extracted by mini-css-extract-plugin
export default {"campaignCard":"CampaignCard_campaignCard__CRyta","gradient":"CampaignCard_gradient__lPsh2","campaignTitle":"CampaignCard_campaignTitle__ZQaX3"};